import React from 'react';

interface VideoPlayerProps {
  src?: string | null;
  videoRef?: React.MutableRefObject<HTMLVideoElement | null>;
  poster?: string | null;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({ src, videoRef, poster }) => {
  if (!src) return null;
  return (
    <div className="mb-2">
      <div className="w-full rounded-md overflow-hidden bg-transparent">
        <video
          id="analysis-video-player"
          ref={videoRef}
          src={src}
          poster={poster || undefined}
          controls
          preload="metadata"
          className="w-full max-h-[320px] h-auto block bg-black"
        />
      </div>
    </div>
  );
};

export default VideoPlayer;
